const LOGIN = "/NafathRestApi/rest/nafath/v1/sendAuthRequest";
const CHECKSTATUS = "/NafathRestApi/rest/nafath/v1/CheckStatusRequest";
const GENERATEJWT = "/NafathRestApi/rest/jwtSecurity/v1/generateJWT";
const RENEWTOKEN = "/NafathRestApi/rest/jwtSecurity/v1/renewJWT";

const exportedObject = {
  LOGIN,
  CHECKSTATUS,
  GENERATEJWT,
  RENEWTOKEN,
};

export default exportedObject;
